<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-12">
                <q-select
                    v-model="RampObj.from_currency"
                    :options="currencies"
                    fill-input
                    option-value="acronym"
                    option-label="name"
                    emit-value
                    map-options
                    :label="$t('ramps.table_titles.from_currency')"
                    :error="RampObj.errors.has('from_currency')"
                    color="input-color"
                    :loading="loading"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section avatar>
                                <q-icon :name="scope.opt.is_fiat ? 'fa fa-dollar-sign' : 'fab fa-btc'" color="purple"/>
                            </q-item-section>
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">({{ scope.opt.acronym }}) - </span>
                                    <span class="text-bold">{{ scope.opt.name }}</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- FROM CURRENCY -->
            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-select
                    v-model="RampObj.on_ramp_operator_id"
                    :label="$t('ramps.table_titles.on_ramp_operator')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="name"
                    :options="operators"
                    :loading="loading"
                    :error="RampObj.errors.has('on_ramp_operator_id')"
                    :error-message="RampObj.errors.get('on_ramp_operator_id')"
                    :rules="[ val => val && val > 0 || $t('ramps.table_titles.on_ramp_operator') + ' is required!']"
                    color="input-color"
                />
            </div> <!-- ON-RAMP OPERATOR -->
            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-select
                    v-model="RampObj.on_ramp_pair_id"
                    :label="$t('ramps.table_titles.on_ramp_exchange')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="symbol"
                    :options="pairs"
                    :loading="loading"
                    :error="RampObj.errors.has('on_ramp_pair_id')"
                    :error-message="RampObj.errors.get('on_ramp_pair_id')"
                    :rules="[ val => val && val > 0 || $t('ramps.table_titles.on_ramp_exchange') + ' is required!']"
                    color="input-color"
                >
                    <template v-slot:selected-item="scope">
                        <div v-if="Object(scope.opt) === scope.opt && 'exchange' in scope.opt">{{ scope.opt.exchange.name }} - <span class="text-caption text-grey">({{ scope.opt.symbol }})</span></div>
                    </template>
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">{{ scope.opt.exchange.name }}</span>
                                    <span> - </span>
                                    <span class="text-bold text-caption text-grey">({{ scope.opt.symbol }})</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- ON-RAMP EXCHANGE -->
            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-input
                    v-model="RampObj.on_ramp_margin"
                    :label="$t('ramps.table_titles.on_ramp_margin')"
                    :error="RampObj.errors.has('on_ramp_margin')"
                    :error-message="RampObj.errors.get('on_ramp_margin')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-percent" />
                    </template>
                </q-input>
            </div> <!-- ON-RAMP MARGIN -->

            <div class="col col-12">
                <q-select
                    v-model="RampObj.asset"
                    :options="crypto_currencies"
                    fill-input
                    option-value="acronym"
                    option-label="name"
                    emit-value
                    map-options
                    :label="$t('ramps.table_titles.asset')"
                    :error="RampObj.errors.has('asset')"
                    color="input-color"
                    :loading="loading"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section avatar>
                                <q-icon :name="scope.opt.is_fiat ? 'fa fa-dollar-sign' : 'fab fa-btc'" color="purple"/>
                            </q-item-section>
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">({{ scope.opt.acronym }}) - </span>
                                    <span class="text-bold">{{ scope.opt.name }}</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- ASSET -->

            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-select
                    v-model="RampObj.off_ramp_operator_id"
                    :label="$t('ramps.table_titles.off_ramp_operator')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="name"
                    :options="operators"
                    :loading="loading"
                    :error="RampObj.errors.has('off_ramp_operator_id')"
                    :error-message="RampObj.errors.get('off_ramp_operator_id')"
                    :rules="[ val => val && val > 0 || $t('ramps.table_titles.off_ramp_operator')+' is required!']"
                    color="input-color"
                />
            </div> <!-- OFF-RAMP OPERATOR -->
            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-select
                    v-model="RampObj.off_ramp_pair_id"
                    :label="$t('ramps.table_titles.off_ramp_exchange')"
                    emit-value
                    map-options
                    option-value="id"
                    option-label="symbol"
                    :options="pairs"
                    :loading="loading"
                    :error="RampObj.errors.has('off_ramp_pair_id')"
                    :error-message="RampObj.errors.get('on_ramp_pair_id')"
                    :rules="[ val => val && val > 0 || $t('ramps.table_titles.off_ramp_exchange') + ' is required!']"
                    color="input-color"
                >
                    <template v-slot:selected-item="scope">
                        <div v-if="Object(scope.opt) === scope.opt && 'exchange' in scope.opt">{{ scope.opt.exchange.name }} - <span class="text-caption text-grey">({{ scope.opt.symbol }})</span></div>
                    </template>
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">{{ scope.opt.exchange.name }}</span>
                                    <span> - </span>
                                    <span class="text-bold text-caption text-grey">({{ scope.opt.symbol }})</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- OFF-RAMP EXCHANGE -->
            <div class="col col-xs-12 col-md-4 col-lg-4">
                <q-input
                    v-model="RampObj.off_ramp_margin"
                    :label="$t('ramps.table_titles.off_ramp_margin')"
                    :error="RampObj.errors.has('off_ramp_margin')"
                    :error-message="RampObj.errors.get('off_ramp_margin')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <q-icon name="fa fa-percent" />
                    </template>
                </q-input>
            </div> <!-- OFF-RAMP MARGIN -->
            <div class="col col-12">
                <q-select
                    v-model="RampObj.to_currency"
                    :options="currencies"
                    fill-input
                    option-value="acronym"
                    option-label="name"
                    emit-value
                    map-options
                    :label="$t('ramps.table_titles.to_currency')"
                    :error="RampObj.errors.has('to_currency')"
                    color="input-color"
                    :loading="loading"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section avatar>
                                <q-icon :name="scope.opt.is_fiat ? 'fa fa-dollar-sign' : 'fab fa-btc'" color="purple"/>
                            </q-item-section>
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">({{ scope.opt.acronym }}) - </span>
                                    <span class="text-bold">{{ scope.opt.name }}</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- TO CURRENCY -->

            <div class="col col-xs-12 col-sm-4 col-md-3">
                <q-input
                    v-model="RampObj.decimals"
                    :label="$t('ramps.table_titles.decimals')"
                    :error="RampObj.errors.has('decimals')"
                    :error-message="RampObj.errors.get('decimals')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                />
            </div> <!-- DECIMALS -->
            <div class="col col-xs-12 col-md-3 col-lg-3">
                <q-input
                    v-model="RampObj.min_transfer_amount"
                    :label="$t('ramps.table_titles.min_transfer_amount')"
                    :error="RampObj.errors.has('min_transfer_amount')"
                    :error-message="RampObj.errors.get('min_transfer_amount')"
                    input-class="text-center"
                    color="input-color"
                >
                    <template v-slot:append>
                        <small>{{RampObj.from_currency || '?'}}</small>
                    </template>
                </q-input>
            </div> <!-- MIN TRANSFER AMOUNT -->
            <div class="col col-xs-12 col-md-3 col-lg-3">
                <q-input
                    v-model="RampObj.max_transfer_amount"
                    :label="$t('ramps.table_titles.max_transfer_amount')"
                    :error="RampObj.errors.has('max_transfer_amount')"
                    :error-message="RampObj.errors.get('max_transfer_amount')"
                    input-class="text-center"
                    color="input-color"
                >
                    <template v-slot:append>
                        <small>{{RampObj.from_currency || '?'}}</small>
                    </template>
                </q-input>
            </div> <!-- MAX TRANSFER AMOUNT -->
            <div class="col col-xs-12 col-md-3 col-lg-3">
                <q-input
                    v-model="RampObj.max_monthly_transfer"
                    :label="$t('ramps.table_titles.max_monthly_transfer')"
                    :error="RampObj.errors.has('max_monthly_transfer')"
                    :error-message="RampObj.errors.get('max_monthly_transfer')"
                    input-class="text-center"
                    color="input-color"
                >
                    <template v-slot:append>
                        <small>{{RampObj.from_currency || '?'}}</small>
                    </template>
                </q-input>
            </div> <!-- MAX MONTHLY TRANSFER -->
            <div class="col col-xs-12 col-sm-4 col-md-3">
                <q-input
                    v-model="RampObj.welcome_reward"
                    :label="$t('ramps.table_titles.welcome_reward')"
                    :error="RampObj.errors.has('welcome_reward')"
                    :error-message="RampObj.errors.get('welcome_reward')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <small>{{RampObj.from_currency || '?'}}</small>
                    </template>
                </q-input>
            </div> <!-- WELCOME REWARD -->
            <div class="col col-xs-12 col-sm-4 col-md-3">
                <q-input
                    v-model="RampObj.service_fee"
                    :label="$t('ramps.table_titles.service_fee')"
                    :error="RampObj.errors.has('service_fee')"
                    :error-message="RampObj.errors.get('service_fee')"
                    input-class="text-center"
                    color="input-color"
                    type="number"
                >
                    <template v-slot:append>
                        <small>{{RampObj.from_currency || '?'}}</small>
                    </template>
                </q-input>
            </div> <!-- SERVICE FEE -->
            <div class="col col-xs-12 col-sm-3 col-md-6">
                <q-input
                    v-model="RampObj.transfer_time"
                    label="Transfer time"
                    :error="RampObj.errors.has('transfer_time')"
                    :error-message="RampObj.errors.get('transfer_time')"
                    type="textarea"
                    autogrow
                    color="input-color"
                />
            </div> <!-- Transfer Time -->
            <div class="col col-xs-12 col-sm-4 col-md-3">
                <p class="text-caption q-pb-xs" style="margin:0">Status</p>
                <q-toggle
                    v-model="RampObj.is_active"
                    checked-icon="fa fa-check"
                    color="positive"
                    unchecked-icon="fa fa-times"
                    :label="RampObj.is_active ? 'Active' : 'Inactive'"
                />
            </div> <!-- IS ACTIVE -->
            <div class="col col-xs-12 col-sm-4 col-md-3">
                <p class="text-caption q-pb-xs" style="margin:0">Permission</p>
                <q-toggle
                    v-model="RampObj.is_private"
                    checked-icon="fa fa-lock"
                    color="input-color"
                    unchecked-icon="fa fa-globe"
                    :label="RampObj.is_private ? 'Private' : 'Public'"
                />
            </div> <!-- IS PRIVATE -->
        </div>
    </form>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'Form',
    model: {
        prop: 'RampObj',
        event: 'change'
    },
    props: {
        RampObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['incoming_currencies', 'currencies', 'crypto_currencies', 'currencies_loading', 'operators', 'pairs']),
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        ...mapActions(['set_operators', 'set_pairs', 'set_currencies']),
        submit() {
            this.$emit('submit')
        },
    },
    created() {
        if (! this.operators.length) {
            this.loading = true
            this.set_operators().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }

        if (! this.pairs.length) {
            this.loading = true
            this.set_pairs().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }

        if (! this.currencies.length) {
            this.loading = true
            this.set_currencies().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    updated() {},
    components: {},
}
</script>

<style scoped>

</style>
